import React from 'react'
import Fade from 'react-reveal/Fade'
import ImageVilla from 'assets/images/img-highlight-villa.png'
import ImageVenue from 'assets/images/img-highlight-venue.png'
import ImageHero_ from 'assets/images/img-hero-frame.jpg'

export default function Highlight(props) {
  return (
    <section
      className="container my-5"
      style={{
        color: "#696969",
        borderTop: "2px solid rgba(105, 105, 105, 0.5)"
      }}
    >
      {/* Header Section */}
      <div className="row text-center justify-content-center" ref={props.refHighlight}>
        <div className="col-lg-8 col-md-10 my-5 px-3">
          <h2 style={{ color: "#333333", fontWeight: "600" }}>
            Tempat Sempurna untuk Setiap Momen
          </h2>
          <p className="lead" style={{ fontSize: "1rem" }}>
            Villa dan venue ideal untuk pesta atau meeting, Green Hill Resort Kemuning Group menyajikan
            keindahan bukit Cipanas Puncak dengan kenyamanan modern untuk momen tak terlupakan.
          </p>
        </div>
      </div>

      {/* Venue Section */}
      <div className="row align-items-center mt-5">
        <Fade>
          <div className="col-lg-7 col-md-12 px-4 mb-4 mb-lg-0">
            <h5 className="fw-semibold mb-2">Venue Event</h5>
            <h3 className="fw-bold mb-3" style={{ color: "#333333" }}>
              Venue Ideal untuk Setiap Momen
            </h3>
            <p className="lead" style={{ fontSize: "1rem" }}>
              Green Hill Resort menawarkan venue Indoor dan Outdoor untuk pesta dan meeting dengan
              pemandangan indah bukit, memadukan keindahan alam dan kenyamanan modern.
            </p>
          </div>
        </Fade>
        <Fade right>
          <div className="col-lg-5 col-md-12 d-flex justify-content-center">
            <div className="position-relative" style={{ maxWidth: "100%", height: "auto" }}>
              <img
                src={ImageVenue}
                className="img-fluid position-relative rounded-3"
                alt="Venue Green Hill"
                style={{ zIndex: 2, maxHeight: 300 }}
              />
              <img
                src={ImageHero_}
                className="img-fluid position-absolute top-50 start-50 translate-middle rounded-3"
                alt="Frame"
                style={{
                  zIndex: 1,
                  opacity: 0.8,
                  width: "95%",
                  height: "auto"
                }}
              />
            </div>
          </div>
        </Fade>
      </div>

      {/* Villa Section */}
      <div className="row align-items-center mt-5 flex-lg-row flex-column-reverse">
        <Fade left>
          <div className="col-lg-5 col-md-12 d-flex justify-content-center mt-4 mt-lg-0">
            <div className="position-relative" style={{ maxWidth: "100%", height: "auto" }}>
              <img
                src={ImageVilla}
                className="img-fluid position-relative rounded-3"
                alt="Villa Green Hill"
                style={{ zIndex: 2, maxHeight: 300 }}
              />
              <img
                src={ImageHero_}
                className="img-fluid position-absolute top-50 start-50 translate-middle rounded-3"
                alt="Frame"
                style={{
                  zIndex: 1,
                  opacity: 0.8,
                  width: "95%",
                  height: "auto"
                }}
              />
            </div>
          </div>
        </Fade>
        <Fade>
          <div className="col-lg-7 col-md-12 px-4">
            <h5 className="fw-semibold mb-2">Villa Green Hill Kemuning</h5>
            <h3 className="fw-bold mb-3" style={{ color: "#333333" }}>
              Ketenangan Alam dan Kenyamanan
            </h3>
            <p className="lead" style={{ fontSize: "1rem" }}>
              Rasakan kenyamanan sejati di villa-villa asri Green Hill Resort, dikelilingi keindahan
              alam dan udara segar Puncak Bogor. Tempat yang tenang dan menyegarkan, sempurna untuk
              liburan atau acara yang tak terlupakan.
            </p>
          </div>
        </Fade>
      </div>
    </section>
  )
}
